import React from 'react';
import Search from '@material-ui/icons/Search';

export default function SearchIcon() {

    return (
        <Search />
    );
};